function ErrorPage() {
  return <div>Some error accured</div>;
}

export default ErrorPage;
